import type {
  ICalculationResultData,
  ILinkBudgetService,
  ILinkBudgetPayloadData
} from './link_budget.types'
import { type AxiosInstance } from 'axios'
import axios from 'axios'

// Create a separate axios instance for link budget service
const linkBudgetAxios = axios.create({
  baseURL: import.meta.env.VITE_APP_LINK_BUDGET_API_URL,
})

export class LinkBudgetService implements ILinkBudgetService {
  private endpoint: string

  constructor(private axios: AxiosInstance) {
    this.endpoint = '/link-budget/link-calculate'
  }

  calculateLinkBudget(data: ILinkBudgetPayloadData): Promise<ICalculationResultData> {
    return this.axios.post(this.endpoint, data).then(({ data }) => data)
  }
}

export const linkBudgetService = new LinkBudgetService(linkBudgetAxios)
